// components/Stats/EnrolledCard.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "@tanstack/react-router";
import StatCard from "./statCard";
import { FaUsers } from "react-icons/fa";
import { Eye } from "lucide-react";
import axios from "axios";
import { courseContent } from "../../data/courseContent";

export default function EnrolledCard({ count, onActionClick, onSwitchTab }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      if (onSwitchTab) {
        await onSwitchTab("students", "all");
      }
      if (onActionClick) {
        await onActionClick();
      }
    } finally {
      setLoading(false);
    }
  };

  const enrolled = courseContent.enrolled;
  const growth = courseContent.enrolledGrowth;

  return (
    <StatCard
      icon={<FaUsers className="w-6 h-6" />}
      label="Enrolled Students"
      subtitle="Enrollment Status Check"
      value={count.toLocaleString()}
      growth={growth}
      actionText="View Students"
      actionIcon={<Eye className="w-4 h-4" />}
      actionColor="primary"
      actionOnClick={handleClick}
      loading={loading}
    />
  );
}
